import { postApi } from "./api_instance";
import toast from "react-hot-toast";

const submitForm = async (data) => {
  const apiUrl = "/api/user/form/save";

  try {
    await postApi({ apiUrl, data });
    toast.success("Form submitted successfully!");
  } catch (error) {
    toast.error(error.message || "Submission failed.");
  }
};

export default submitForm;
